import React, { useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SpeedDial } from 'primereact/speeddial';
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import InputTextCNPJ from "../../../Componentes/InputTextCNPJ"; // Verifique se o caminho está correto
import InputTextCPF from "../../../Componentes/InputTextCPF";
import InputCEP from "../../../Componentes/InputTextCEP";
import InputTextTelefone from "../../../Componentes/InputTextTelefone";
import InputTextEmail from "../../../Componentes/InputTextEmail";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Slider } from "primereact/slider";


export default function FormEditaEmpresa(props) {
    const [visible, setVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [tipoCadastro, setTipoCadastro] = useState('juridica'); // Inicializa como 'juridica'
    const {idusuario, Conexao} = props
    const toast = React.useRef(null); // Ref para o Toast
    const [empresa, setEmpresa] = useState({
        bairro: props.empresa.bairro,
        cep: props.empresa.cep,
        cidade: props.empresa.cidade,
        cnpj: props.empresa.cpf_cnpj,
        complemento: props.empresa.complemento,
        email: props.empresa.email,
        endereco: props.empresa.logradouro,
        estado: props.empresa.estado,
        idempresa: props.empresa.idempresa,
        idusuario: idusuario,
        inscEstadual: props.empresa.rg_insc,
        latitude: props.empresa.latitude,
        longitude: props.empresa.longitude,
        raio : props.empresa.raio,
        nomeFantasia: props.empresa.nomefantasia,
        numero: props.empresa.numero,
        razaoSocial: props.empresa.razaosocial,
        telefoneCelular: props.empresa.telefonecelular,
        telefoneComercial: props.empresa.telefonecomercial
    });
    useEffect(()=>{
        if(props.empresa.cpf_cnpj){
            
            setTipoCadastro(props.empresa.cpf_cnpj.length== 14 ? 'fisica' : 'juridica')

        }
  
    }, [props.empresa])

    useState(()=>{
        if(visible){
            
            setTipoCadastro(props.empresa.cpf_cnpj.length== 14 ? 'fisica' : 'juridica')        
            setEmpresa({
                bairro: props.empresa.bairro,
                cep: props.empresa.cep,
                cidade: props.empresa.cidade,
                cnpj: props.empresa.cpf_cnpj,
                complemento: props.empresa.complemento,
                email: props.empresa.email,
                endereco: props.empresa.logradouro,
                estado: props.empresa.estado,
                idempresa: props.empresa.idempresa,
                idusuario: idusuario,
                inscEstadual: props.empresa.rg_insc,
                latitude: props.empresa.latitude,
                longitude: props.empresa.longitude,
                raio : props.empresa.raio,
                nomeFantasia: props.empresa.nomefantasia,
                numero: props.empresa.numero,
                razaoSocial: props.empresa.razaosocial,
                telefoneCelular: props.empresa.telefonecelular,
                telefoneComercial: props.empresa.telefonecomercial
            })
            if (!props.empresa || Object.keys(props.empresa).length === 0 || !props.empresa.idempresa || props.empresa.idempresa.trim() === "" || !props.empresa.cpf_cnpj.trim() === "" || props.empresa.cpf_cnpj.trim() === "") {
                setVisible(false);
            }
            
        }
    }, [visible])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmpresa(prevState => ({
            ...prevState,
            [name]: value
        }));
    };




    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };
   const updateEmpresa = (updateEmpresa) =>{
   
           
           props.setLoading(true);
           Conexao.post('empresasController/updateEmpresa', 
               { ...updateEmpresa})
           .then(response => {
   
               if (response.status === 200 && response.data.status === 'OK') {
                   setVisible(false)
                   showMessageToast('success', "Registro inserido com sucesso !");                
                   props.getData();
                   setEmpresa([])
                   
               } else {
   
                   showMessageToast('warn', "Não foi possível cadastrar empresa");
   
               }
   
               props.setLoading(false);
               
           }).catch(error => {
               showMessageToast('error', "Erro ao inserir registro");
               props.setLoading(false);
           });
   
       }

       const validateFields = () => {
        let newErrors = {};
    
        if (!empresa.cnpj.trim()) newErrors.cnpj = "CPF/CNPJ é obrigatório";
        if (!empresa.razaoSocial.trim()) newErrors.razaoSocial = "Razão Social/Nome Completo é obrigatório";
        if (!empresa.nomeFantasia.trim()) newErrors.nomeFantasia = "Nome Fantasia/Apelido é obrigatório";
        if (!empresa.email.trim()) newErrors.email = "E-mail é obrigatório";
        if (!empresa.cidade.trim()) newErrors.cidade = "A Cidade é obrigatório";
        if (!empresa.estado.trim()) newErrors.estado = "UF é obrigatório";
        if (!empresa.cep.trim()) newErrors.cep = "CEP é obrigatório";
    
        setErrors(newErrors);
    
        return Object.keys(newErrors).length === 0; // Retorna true se não houver erros
    };

    return (
        <div style={{ backgroundColor: 'red', width: '100%' }}>
            
            <Button label="Editar" icon="pi pi-pencil"onClick={() => {
                setVisible(true)
                setTipoCadastro(props.empresa.cpf_cnpj.length== 14 ? 'fisica' : 'juridica')        
                setEmpresa({
                    bairro: props.empresa.bairro,
                    cep: props.empresa.cep,
                    cidade: props.empresa.cidade,
                    cnpj: props.empresa.cpf_cnpj,
                    complemento: props.empresa.complemento,
                    email: props.empresa.email,
                    endereco: props.empresa.logradouro,
                    estado: props.empresa.estado,
                    idempresa: props.empresa.idempresa,
                    idusuario: idusuario,
                    inscEstadual: props.empresa.rg_insc,
                    latitude: props.empresa.latitude,
                    longitude: props.empresa.longitude,
                    raio: props.empresa.raio,
                    nomeFantasia: props.empresa.nomefantasia,
                    numero: props.empresa.numero,
                    razaoSocial: props.empresa.razaosocial,
                    telefoneCelular: props.empresa.telefonecelular,
                    telefoneComercial: props.empresa.telefonecomercial
                })
            }} className="p-button-primary w-full" size="large" />
            <Dialog
                header="Editar dados Empresa"
                visible={visible}
                maximizable
                blockScroll={false} 
                style={{ width: '60vw' }} // Largura padrão
                breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
                onHide={() => setVisible(false)}
            >
                {/* Opção de Pessoa Jurídica ou Física */}
                <div className="flex flex-wrap gap-3">
                    <div className="flex align-items-center col-12 md:col-3">
                        <RadioButton
                            inputId="juridica"
                            name="tipoCadastro"
                            value="juridica"
                            onChange={(e) => setTipoCadastro(e.value)}
                            checked={tipoCadastro === 'juridica'}
                        />
                        <label htmlFor="juridica" className="ml-2">Pessoa Jurídica</label>
                    </div>

                    <div className="flex align-items-center col-12 md:col-3">
                        <RadioButton
                            inputId="fisica"
                            name="tipoCadastro"
                            value="fisica"
                            onChange={(e) => setTipoCadastro(e.value)}
                            checked={tipoCadastro === 'fisica'}
                        />
                        <label htmlFor="fisica" className="ml-2">Pessoa Física</label>
                    </div>
                </div>

                {/* Formulário em Grid Responsivo */}
                <div className="grid mt-2">
                    {/* CPF/CNPJ */}
                    <div className="col-12 md:col-3">
                        <label htmlFor="documento">{tipoCadastro === 'juridica' ? 'CNPJ*' : "CPF*"}</label>
                        {
                            tipoCadastro === 'juridica' ?
                            <>
                                <InputTextCNPJ
                                    value={empresa.cnpj}
                                    onChange={handleChange}
                                    name="cnpj"
                                    className="w-full mt-2"

                                />
                                <small className="p-error">{errors.cnpj}</small>
                                </>
                                :
                                <>
                                <InputTextCPF
                                    value={empresa.cnpj}
                                    onChange={handleChange}
                                    name="cnpj"
                                    className="w-full mt-2"
                                />
                                <small className="p-error">{errors.cnpj}</small>
                                </>
                        }
                    </div>

                    {/* RG/Inscrição Estadual */}
                    <div className="col-12 md:col-2">
                        <label htmlFor="inscEstadual">{tipoCadastro === 'juridica' ? 'IE' : "RG"}</label>
                        <InputText
                            value={empresa.inscEstadual}
                            onChange={handleChange}
                            name="inscEstadual"
                            className="w-full mt-2"
                        />
                    </div>

                    {/* Razão Social */}
                    <div className="col-12 md:col-7">
                        <label htmlFor="razaoSocial">{tipoCadastro === 'juridica' ? 'Razão Social*' : "Nome Completo*"}</label>
                        <>
                        <InputText
                            value={empresa.razaoSocial}
                            onChange={handleChange}
                            name="razaoSocial"
                            className="w-full mt-2"
                        />
                          <small className="p-error">{errors.razaoSocial}</small>
                          </>
                    </div>
                </div>

                <div className="grid mt-2">
                    {/* Nome Fantasia */}
                    <div className="col-12 md:col-4">
                        <label htmlFor="nomeFantasia">{tipoCadastro === 'juridica' ? 'Nome Fantasia*' : "Apelido*"}</label>
                        <>
                        <InputText
                            value={empresa.nomeFantasia}
                            onChange={handleChange}
                            name="nomeFantasia"
                            className="w-full mt-2"
                        />
                         <small className="p-error">{errors.nomeFantasia}</small>
                         </>
                    </div>

                    {/* CEP */}
                    <div className="col-12 md:col-2">
                        <label htmlFor="cep">CEP*</label>
                        <>
                        <InputCEP
                            value={empresa.cep}
                            onChange={handleChange}
                            name="cep"
                            setDataCep = {(data)=>{
                               if(data){
                                    setEmpresa((prevEmpresa)=>({
                                        ...prevEmpresa, 
                                        endereco : data.logradouro, 
                                        complemento : data.complemento, 
                                        bairro : data.bairro, 
                                        cidade : data.localidade,
                                        estado : data.uf
                                    }))
                                }
                            }} 
                            className="w-full mt-2"
                            setLoading={props.setLoading}
                        />
                         <small className="p-error">{errors.cep}</small>
                         </>
                    </div>

                    {/* Logradouro */}
                    <div className="col-12 md:col-5">
                        <label htmlFor="endereco">Logradouro</label>
                        <InputText
                            value={empresa.endereco}
                            onChange={handleChange}
                            name="endereco"
                            className="w-full mt-2"
                        />
                    </div>

                    {/* Número */}
                    <div className="col-12 md:col-1">
                        <label htmlFor="numero">Nº</label>
                        <InputText
                            value={empresa.numero}
                            onChange={handleChange}
                            name="numero"
                            className="w-full mt-2"
                        />
                    </div>
                </div>

                <div className="grid mt-2">
                    {/* Bairro */}
                    <div className="col-12 md:col-4">
                        <label htmlFor="bairro">Bairro</label>
                        <InputText
                            value={empresa.bairro}
                            onChange={handleChange}
                            name="bairro"
                            className="w-full mt-2"
                        />
                    </div>

                    {/* Cidade */}
                    <div className="col-12 md:col-7">
                        <label htmlFor="cidade">Cidade*</label>
                        <>
                        <InputText
                            value={empresa.cidade}
                            onChange={handleChange}
                            name="cidade"
                            className="w-full mt-2"
                        />
                         <small className="p-error">{errors.cidade}</small>
                         </>
                    </div>

                    {/* Estado */}
                    <div className="col-12 md:col-1">
                        <label htmlFor="estado">UF*</label>
                        <>
                        <InputText
                            value={empresa.estado}
                            onChange={handleChange}
                            name="estado"
                            className="w-full mt-2"
                        />
                         <small className="p-error">{errors.estado}</small>
                         </>
                    </div>
                </div>

                <div className="grid mt-2">
                    {/* Telefone Celular */}
                    <div className="col-12 md:col-3">
                        <label htmlFor="telefoneCelular">Telefone Celular</label>
                        <InputTextTelefone
                            value={empresa.telefoneCelular}
                            onChange={handleChange}
                            name="telefoneCelular"
                            className="w-full mt-2"
                        />
                    </div>

                    {/* Telefone Comercial */}
                    <div className="col-12 md:col-3">
                        <label htmlFor="telefoneComercial">Telefone Comercial</label>
                        <InputTextTelefone
                            value={empresa.telefoneComercial}
                            onChange={handleChange}
                            name="telefoneComercial"
                            className="w-full mt-2"
                        />
                    </div>

                    {/* E-mail */}
                    <div className="col-12 md:col-6">
                        <label htmlFor="email">E-mail*</label>
                        <>
                        <InputTextEmail
                            value={empresa.email}
                            onChange={handleChange}
                            name="email"
                            className="w-full mt-2"
                        />
                         <small className="p-error">{errors.email}</small>
                         </>
                    </div>

                    <div className="col-12 md:col-3">
                        <label htmlFor="email">Latitude</label>
                        <>
                        <InputText
                            value={empresa.latitude}
                            onChange={handleChange}
                            name="latitude"
                            className="w-full mt-2"
                        />
                            <small className="p-error">{errors.latitude}</small>
                            </>
                    </div>
                    <div className="col-12 md:col-3">
                        <label htmlFor="email">Longitude</label>
                        <>
                        <InputText
                            value={empresa.longitude}
                            onChange={handleChange}
                            name="longitude"
                            className="w-full mt-2"
                        />
                            <small className="p-error">{errors.longitude}</small>
                            </>
                    </div>

                    <div className="col-12 md:col-3">
                        <label htmlFor="email">Raio de atuação (em quilômetros)</label>
                        <>
                     
                       <InputText
                            value={empresa.raio}
                            onChange={handleChange}
                            name="raio"
                            className="w-full mt-2"
                        />
                         <small className="p-error">{errors.raio}</small>
                         </>
                    </div>
                </div>

                {/* Botão de Enviar */}
                <div className="mt-4 flex justify-content-end mt-2">
                    <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                         confirmDialog({
                            message: 'Deseja cancelar?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {setVisible(false)}
                        });
                    }} />
                    <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                         if(!validateFields()){
                            showMessageToast("warn", "Preencha todos os campos obrigatórios.");
                           // return
                        }
                         confirmDialog({
                            message: 'Confirma a inclusão dessa nova empresa?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {
                                updateEmpresa(empresa)
                            } 
                        });
                    }} />
                </div>
                
            </Dialog>
            <Toast ref={toast} />
        </div>
    );
}
